import React from "react";
import Modal from "@/components/controls/Modal";
import { Button } from "@/components/ui/button";
import Text from "@/components/ui/text";
import { cn } from "@/utils/utils";

interface Props {
  isOpen: boolean;
  title: string;
  message: string;
  discardButtonText: string;
  cancelButtonText: string;
  onDiscard: () => void;
  onCancel: () => void;
  // The title as written; the heading style otherwise capitalizes each word.
  sentenceCaseTitle?: boolean;
}

const UnsavedChangesWarningDialog: React.FC<Props> = ({
  isOpen,
  title,
  message,
  discardButtonText,
  cancelButtonText,
  onDiscard,
  onCancel,
  sentenceCaseTitle = false
}) => {
  return (
    <Modal
      open={isOpen}
      setIsOpen={(open) => !open && onCancel()}
      contentClassname="w-[35rem]"
      title={
        <Text
          as="div"
          variant="lgSubtitleH1"
          className={cn(sentenceCaseTitle && "normal-case")}
        >
          {title}
        </Text>
      }
      content={
        <div className="flex flex-col gap-3 h-fit w-[35rem] p-4">
          <Text as="div" variant="body" className="mt-2">
            {message}
          </Text>
        </div>
      }
      footer={
        <div className="flex justify-end gap-2">
          <Button
            data-test="cancel-discard"
            variant="secondaryNoBg"
            onClick={onCancel}
          >
            {cancelButtonText}
          </Button>
          <Button data-test="confirm-discard" destructive onClick={onDiscard}>
            {discardButtonText}
          </Button>
        </div>
      }
      hideDivider
    />
  );
};

export default UnsavedChangesWarningDialog;
